module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_vm._v("Copyright")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t2"
  }, [_c('img', {
    attrs: {
      "alt": "img2.jpg",
      "height": "48",
      "src": "Images/img2.jpg",
      "width": "48"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Publicado por")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("D"), _c('span', {
    staticClass: "t3"
  }, [_vm._v("REAMSPINNER")]), _vm._v(" P"), _c('span', {
    staticClass: "t3"
  }, [_vm._v("RESS")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("5032 Capital Circle SW, Suite 2, PMB# 279, Tallahassee, FL 32305-7886  USA")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("http://www.dreamspinnerpress.com/")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Esta historia es ficción. Los nombres, personajes, lugares y acontecimientos son producto de la imaginación del autor o se utilizan para la ficción y cualquier semejanza con personas vivas o muertas, negocios, eventos o escenarios, es mera coincidencia.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Sobre luces y sombras")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Edición de copyright en español © 2015 Dreamspinner Press.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Título original: Of Dark and Bright")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("© 2012")]), _vm._v(" "), _c('span', {
    staticClass: "t2"
  }, [_vm._v("Kate Sherwood")]), _c('span', {
    staticClass: "t2"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Traducido por: Georgette Asi.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Portada:")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("© 2012 Justin James.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("dare.empire@gmail.com")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Diseño de portada:")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("© 2012 Mara McKennen.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("El contenido de la portada ha sido creado exclusivamente con propósito ilustrativo y todas las personas que aparecen en ella son modelos.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("La licencia de este libro pertenece exclusivamente al comprador original. Duplicarlo o reproducirlo por cualquier medio es ilegal y constituye una violación a la ley de Derechos de Autor Internacional. Este eBook no puede ser prestado legalmente ni regalado a otros. Ninguna parte de este eBook puede ser compartida o reproducida sin el permiso expreso de la editorial. Para solicitar el permiso y resolver cualquier duda, contactar con Dreamspinner Press 5032 Capital Cir. SW, Ste 2 PMB# 279, Tallahassee, FL 32305-7886 USA or http://www.dreamspinnerpress.com/.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Edición eBook en español: 978-1-62380-883-9")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Primera edición en español Agosto 2015")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Primera Edición Marzo 2012")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Publicado en los Estados Unidos de América.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ddddfc7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/003.vue
// module id = 60
// module chunks = 0